// eslint-disable-next-line
'use strict'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { useEnv } from '@praxis/component-runtime-env'
// import { useEffect } from 'react'
import AppHeader from './components/AppHeader'
import FormNavbar from './components/FormNavbar'
import Footer from './components/Footer'
import Details from './components/Details'
import GuestDetails from './components/GuestDetails'

import { OpenTelemetryManager } from '@measurement/opentelemetry-web'

const openTelemetryConfig = {
  apiKey: '202a6f61df422e6be81214455f2de9d4a4a8a447',
  serviceName: 'guestwifiui',
}

OpenTelemetryManager.initialize(openTelemetryConfig)

export const App = () => {
  const env = useEnv()
  return (
    <Router>
      <AppHeader />
      <FormNavbar env={env} />
      <Switch>
        {/* <Route path="/" render={(props) => <HomePage {...props} env={env} />} /> */}
        <Route
          path="/tm"
          render={(props) => <Details {...props} env={env} />}
        />
        <Route
          path="/guest"
          render={(props) => <GuestDetails {...props} env={env} />}
        />
      </Switch>
      <Footer />
    </Router>
  )
}
export default App
